import { cn } from '@/lib/cn';

export interface TimeFilterItemProps {
  label: string;
  selected?: boolean;
  onClick?: () => void;
  className?: string;
}

/**
 * Figma TimeFilterItem — pill chip for hour windows.
 * Selected: elevated fill + primary text.
 * Default: subtle border + secondary text.
 */
export function TimeFilterItem({
  label,
  selected = false,
  onClick,
  className,
}: TimeFilterItemProps) {
  return (
    <button
      type="button"
      role="listitem"
      onClick={onClick}
      aria-pressed={selected}
      className={cn(
        'flex h-8 shrink-0 items-center justify-center rounded-full px-4 py-2 text-label-s whitespace-nowrap',
        selected
          ? 'bg-bg-elevated text-text-primary'
          : 'border border-border-subtle text-text-secondary',
        className,
      )}
    >
      {label}
    </button>
  );
}
